export function pluralize(word: string, count: number): string {
  return count === 1 ? word : `${word}s`
}

export function pluralizeCount(word: string, count: number) {
  return `${count} ${pluralize(word, count)}`
}
